//- Remunerations headers for employee details tab
import moment from 'moment'
export default [
    {
        text: '#',
        value: 'id',
        sortable: false,
    },
    {
        text: 'Código',
        value: 'code',
        sortable: false,
    },
    {
        text: 'Responsable',
        value: 'generatorUserName',
        sortable: false,
    },
    {
        text: 'Fecha Inicio',
        value: 'initDate',
        sortable: false,
    },
    {
        text: 'Fecha Término',
        value: 'endDate',
        sortable: false,
    },
]
